import { render, staticRenderFns } from "./RelResumoServicos.vue?vue&type=template&id=13866804"
import script from "./RelResumoServicos.vue?vue&type=script&lang=js"
export * from "./RelResumoServicos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports